module.exports = __webpack_public_path__ + "static/img/qr-code3.975b538.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr-code3.jpeg
// module id = AwkB
// module chunks = 0